import {AfterViewInit, Component, Inject, QueryList, ViewChild} from '@angular/core';
import {DialogResult, DialogResultType} from '../DialogResult';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {InteractPoDPage} from '../../api/models/interact-po-dpage';
import {Observable} from 'rxjs/internal/Observable';
import {MatList, MatListOption, MatSelectionList, MatSelectionListChange} from '@angular/material/list';
import {PodLayoutEx} from '../../api/models/pod-layout-ex';
import {US_Bookmark} from '../../api/models/us_bookmark';
import {US_SubHeader} from '../../api/models/us_sub-header';
import {ShareState} from '../../elements/share-editor/share-editor.component';

export enum PrintOnDemandFileType {
  PDF = 0,
  PPTX = 1,
  PNG = 2,
  XLSX = 3,
  DOCX = 4,
  CSV = 5,
  XML = 6,
  MHTML = 7
}

export class PodLayoutDialogData {
  podLayout: PodLayoutEx;
  pages: InteractPoDPage[];
  bookmarks: US_Bookmark[];
  availableSubscriptions: US_SubHeader[];
  shareState: ShareState;
  isOwner: boolean;
}

export class PrintOnDemandLayoutDialogResult {
  podLayout: PodLayoutEx;
  shareState: ShareState;
}

@Component({
  selector: 'print-on-demand-layout-dialog',
  templateUrl: './print-on-demand-layout-dialog.component.html',
})
export class PrintOnDemandLayoutDialogComponent {

  public result: PrintOnDemandLayoutDialogResult;
  public selectedBookmarkId: number = -1;
  public selectedSubscriptionId: number = -1;
  public shareState: ShareState;
  public isOwner: boolean;

  constructor(
    public dialogRef: MatDialogRef<PrintOnDemandLayoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PodLayoutDialogData
  ) {

    this.result = {
      podLayout: JSON.parse(JSON.stringify(data.podLayout)),
      shareState: data.shareState
    }

    if (data.podLayout.pages && data.podLayout.pages.length > 0) {
      this.result.podLayout.pages = JSON.parse(JSON.stringify(data.podLayout.pages));
    } else {
      this.result.podLayout.pages = JSON.parse(JSON.stringify(data.pages));
    }

    this.selectedSubscriptionId = this.data.availableSubscriptions[0].subscriptionId;
    this.shareState = data.shareState;
    this.isOwner = data.isOwner;

    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  isOptionSelected(page: InteractPoDPage) {
    return this.result.podLayout.pages.findIndex(x => x.interactPoDPageId === page.interactPoDPageId) >= 0
  }

  public Result: DialogResult;

  static showDialog(
    dialog: MatDialog,
    podLayout: PodLayoutEx,
    bookmarks: US_Bookmark[],
    pages: InteractPoDPage[],
    availableSubscriptions: US_SubHeader[],
    shareState: ShareState,
    isOwner: boolean
  ): Observable<any> {
    const params: PodLayoutDialogData = {
      podLayout,
      bookmarks,
      pages,
      availableSubscriptions,
      shareState,
      isOwner
    };

    const dialogRef = dialog.open(PrintOnDemandLayoutDialogComponent, {
      disableClose: true,
      width: '750px',
      data: params,
    });

    return dialogRef.afterClosed();
  }

  selectedBookmarkChanged() {
    this.selectedSubscriptionId = this.data.availableSubscriptions[0].subscriptionId;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onPreviewLayout(): void {
    this.closeDialog();
  }

  closeDialog(): void {
    if(this.selectedBookmarkId === -1) {
      this.result.podLayout.bookmarkId = undefined;
      this.result.podLayout.subscriptionId = this.selectedSubscriptionId;
    } else {
      this.result.podLayout.bookmarkId = this.selectedBookmarkId;
      this.result.podLayout.subscriptionId = this.data.bookmarks.find(x => x.bookmarkId === this.selectedBookmarkId).subscriptionId;
      this.result.podLayout.bookmarkData = undefined;
    }

    this.result.shareState = this.shareState;

    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onSelectionChange(event: MatSelectionListChange) {
    this.result.podLayout.pages = event.source.selectedOptions.selected.map(item => JSON.parse(JSON.stringify(item.value)));
  }
}
